import React from "react";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import "./Cards.css";
import bootstrapImg from "../assets/bootstrap.jpg";
import todoImg from "../assets/todo.jpg";
import payCalcImg from "../assets/paycalc.jpg";

const projectData = [
  {
    title: "To-Do Buddy ✧",
    description:
      "A magical task tracker to help keep your brain decluttered. Coded with React, Vite, and CSS.",
    image: todoImg,
    imageAlt:
      "Screenshot of To-Do Buddy application showing task management interface",
    link: "https://react-todo-two-gray.vercel.app/",
  },
  {
    title: "React Bootstrap Template 🎨",
    description:
      "A responsive website template built with various Bootstrap components using React JSX, CSS, and Bootstrap.",
    image: bootstrapImg,
    imageAlt:
      "Screenshot of React Bootstrap Template showing responsive layout examples",
    link: "https://react-bootstrap-practice.vercel.app/",
  },
  {
    title: "Employee Pay Calculator 💼",
    description:
      "An app to calculate employee wages based on hours worked and rate of pay. Coded in C++.",
    image: payCalcImg,
    imageAlt:
      "Screenshot of Employee Pay Calculator showing wage calculation form",
    link: "https://github.com/mlilu/pay-calculator",
  },
];

const Cards = () => {
  return (
    <section className="projects-container">
      <h1 className="projects-title">My Projects</h1>
      <Row xs={1} md={2} className="g-4" as="ul" style={{ listStyle: "none" }}>
        {projectData.map((project, idx) => (
          <Col key={idx} as="li">
            <a
              href={project.link}
              target="_blank"
              rel="noopener noreferrer"
              className="card-link"
              aria-label={`${project.title} - ${project.description} (opens in new window)`}
            >
              <Card className="project-card">
                <Card.Img
                  variant="top"
                  src={project.image}
                  alt={project.imageAlt}
                  className="project-img"
                />
                <Card.Body>
                  <Card.Title className="project-title">
                    {project.title}
                  </Card.Title>
                  <Card.Text className="project-desc">
                    {project.description}
                  </Card.Text>
                </Card.Body>
              </Card>
            </a>
          </Col>
        ))}
      </Row>
    </section>
  );
};

export default Cards;
